<template>
  <div :class="`as-football-team ${modeTeam} ${modifyClass}`">
    <div class="as-football-team__head" v-if="showName">
      {{
        modeTeam == "as-away" ? footyStats?.away_name : footyStats?.home_name
      }}
      {{ modeTeam == "as-away" ? "(Đội khách)" : "(Đội nhà)" }}
    </div>
    <div class="as-football-team__body">
      <div class="as-team-img" v-if="showLogo">
        <img
          class="as-team-img__logo"
          :src="
            getImageUrl(
              modeTeam == 'as-away'
                ? footyStats?.away_image
                : footyStats?.home_image
            )
          "
        />
      </div>
      <div class="as-team-info">
        <div
          :class="`as-team-info__point as-${setClassForTeamItem(
            homePoint,
            awayPoint,
            modeTeam
          )}`"
          v-if="showStatus"
        >
          <span class="as-team">
            {{ modeTeam == "as-away" ? awayPoint : homePoint }}
          </span>
        </div>
        <div
          class="as-team-info__result"
          v-if="showResult && fivePreviousMatches.length"
        >
          <span
            :class="`as-${setClassForTeamItem(
              item.team_a_goals,
              item.team_b_goals,
              modeTeam
            )}`"
            v-for="(item, index) in fivePreviousMatches"
            :key="index"
          >
            {{
              setClassForTeamItem(
                item.team_a_goals,
                item.team_b_goals,
                modeTeam
              )
            }}
          </span>
        </div>
      </div>
      <div class="as-team-info as-team-info__only-name" v-if="showOnlyName">
        {{
          modeTeam == "as-away" ? footyStats?.away_name : footyStats?.home_name
        }}
      </div>
      <div class="as-team-info as-team-info__only-state" v-if="showState">
        Hiệp 1
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IMatch } from "~src/interfaces";
import type {
  IFootyStats,
  IPreviousMatchId,
  IStatsParent,
} from "~src/interfaces/footystats";
import { getImageUrl } from "~src/helpers/footystats";
import { computed, onMounted, ref } from "vue";

interface Props {
  match: IMatch;
  footyStats: IFootyStats | null;
  modeTeam?: string;
  mode?: string;
  modifyClass?: string;
  showName?: boolean;
  showOnlyName?: boolean;
  showLogo?: boolean;
  showStatus?: boolean;
  showResult?: boolean;
  showState?: boolean;
  status?: string;
  homePoint?: number;
  awayPoint?: number;
}

const props = withDefaults(defineProps<Props>(), {
  modeTeam: "",
  footyStats: null,
  modifyClass: "",
  mode: "",
  showName: true,
  showLogo: true,
  showStatus: true,
  showResult: true,
  showOnlyName: false,
  showState: false,
  status: "as-D",
  homePoint: 0,
  awayPoint: 0
});

const fivePreviousMatches = ref<IPreviousMatchId[] | []>([]);
onMounted(() => {
  if (props.footyStats && props.footyStats?.h2h) {
    if (
      props.footyStats?.h2h?.previous_matches_results &&
      props.footyStats?.h2h?.previous_matches_ids
    ) {
      fivePreviousMatches.value =
        props.footyStats.h2h.previous_matches_ids.slice(0, 5);
    }
  }
});

const setClassForTeamItem = (home: number, away: number, mode = "home") => {
  let __class = "";
  let num_1 = home;
  let num_2 = away;
  if (mode === "as-away") {
    num_1 = away;
    num_2 = home;
  }
  if (num_1 > num_2) {
    __class = "W";
  } else if (num_1 < num_2) {
    __class = "L";
  } else {
    __class = "D";
  }
  return __class;
};
</script>

<script lang="ts">
export default {};
</script>
